import React, { createContext, useContext, useEffect, useState } from 'react';
import secretaria_api from '../api/secretaria_api';
import setup_api from '../api/setup_api';

//Helpers
import { getSessionCookie, setSessionCookie, removeAllCookies } from '../helpers/cookies';
import { showMessage } from '../helpers/message';

function initialContext() {
    return {
        loading: false,
        isSignout: false,
        session: null
    }
}
export const AuthContext = createContext(initialContext());

const AuthProvider = ({ children }) => {
    //Estados de autenticação
    const [loading, setLoading] = useState(false);
    const [session, setSession] = useState(null);
    const nomeSistema = "FiscSP";
    const subtituloLogin = "Autos de Infração Online";
    const [logoSistema, setLogoSistema] = useState(require('../assets/img/logo_sistema.png'));
    const [logoPrefeitura, setLogoPrefeitura] = useState("");
    const [logoSecretaria, setLogoSecretaria] = useState("");
    const [dadosSecretaria, setDadosSecretaria] = useState();

    //Função que faz o controle de signIn
    const signIn = async (data) => {
        await setSessionCookie(data);
        if (data.secretaria_Id) {
            secretaria_api.getLogotipo(data.secretaria_Id).then(response => {
                setLogoSecretaria(response.data);
            }).catch(ex => showMessage("Erro", ex.Message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(false);
        }
        // setSession(data);
    }
    const signOut = async (token) => {
        if (!token)
            removeAllCookies();
        else {
            const usuario = await getSessionCookie();
            delete usuario.token;
            setSessionCookie(usuario);
        }
        setSession(null);
    }
    const loadAsync = async () => {
        try {
            const data = await getSessionCookie();

            if (data && data.secretaria_Id) {
                secretaria_api.getLogotipo(data.secretaria_Id).then(response => {
                    setLogoSecretaria(response.data);
                }).catch(ex => showMessage("Erro", ex.Message, "error", null))
                    .finally(f => setLoading(false));
            }

            setup_api.GetLogotipos().then(response => {
                setLogoPrefeitura(response.data.logotipoPrefeitura);
                if (response.data.logotipoSistema)
                    setLogoSistema(response.data.logotipoSistema);
            }).catch(ex => showMessage("Erro", ex.Message, "error", null))
                .finally(f => setLoading(false));

            secretaria_api.getItem(data.secretaria_Id).then(response => {
                setDadosSecretaria(response.data);
            }).catch(ex => showMessage("Erro", ex.Message, "error", null))
                .finally(f => setLoading(false));

            setSession(data);
        } catch (e) {
            setLoading(false);
        }
    };

    // Valida se o usuario ja esta logado e acessa direto o sistema
    useEffect(() => {
        loadAsync();
    }, []);



    return (
        <AuthContext.Provider value={{
            loading,
            setLoading,
            session,
            signIn,
            signOut,
            nomeSistema,
            subtituloLogin,
            logoSistema,
            logoPrefeitura,
            logoSecretaria,
            dadosSecretaria,
            setLogoSistema,
            setLogoPrefeitura,
            setLogoSecretaria
        }}>
            {children}
        </AuthContext.Provider>
    );
}
export function useAuth() {
    const context = useContext(AuthContext)

    return context

}

export default AuthProvider;